var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('controls',[_c('GoToExternalAppStoreLink'),_vm._v(" "),_c('ActivateLicenseKeyButton'),_vm._v(" "),_c('div',{staticClass:"filters"},[_c('div',{staticClass:"modules-list-filters"},[_c('dropdown-select',{attrs:{"value":_vm.filter.sortBy,"options":_vm.filterOptions},on:{"selected":_vm.filterHandler}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278ed06a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/controls/ModulesControls.vue
// module id = null
// module chunks = 